import * as yup from "yup"

export const usageValidation = yup.object().shape({
    coa_asset_id: yup.string().label("Asset Coa").optional(),
    coa_disposal_id : yup.string().label("Disposal Coa").optional(),
    net_book_value: yup.number().label("Net Book Value").optional(),
    memo: yup.string().label("Memo").optional(),
    date_disposal: yup.string().label("Date Disposal").optional(),
})

export type UsageType = yup.InferType<typeof usageValidation>